// extracted by mini-css-extract-plugin
export default {"addToCartBtn":"AddToCard_addToCartBtn__BU2oN"};